module.exports = __webpack_public_path__ + "img/loader.2b02159f.gif";